import { RadioProps } from 'antd';
import styles from './radio.module.scss';
import Radio from 'antd/es/radio/radio';

export default function CustomRadio({ ...restProps }: RadioProps) {
  return <Radio {...restProps} className={styles.radio}></Radio>;
}
